import axios from "axios";
import Links from "../constants/Links";

/**
 * Graduation Config API service for managing graduation configurations per department
 * (C) 2021-2025
 */
const GraduationConfig = {
    /**
     * Get graduation config by department and semester
     * @param {number} departmentId the department ID
     * @param {number} semesterId the semester ID
     * @returns {Promise<object>} graduation config data
     */
    getByDepartmentSemester: async (departmentId, semesterId) => {
        return axios.get(`${Links.graduationConfig.getByDepartmentSemester}${departmentId}/${semesterId}`)
    },

    /**
     * Create or update a graduation config
     * @param {object} data config data containing departmentId, semesterId, graduationDate, enabled
     * @returns {Promise<object>} created/updated config
     */
    createOrUpdate: async (data) => {
        return axios.post(Links.graduationConfig.createOrUpdate, data)
    },

    /**
     * Queue graduation for immediate processing
     * @param {number} id the graduation config ID
     * @returns {Promise<object>} queued config
     */
    queue: async (id) => {
        return axios.post(`${Links.graduationConfig.queue}${id}/queue`)
    },

    /**
     * Get all graduation configs for a semester
     * @param {number} semesterId the semester ID
     * @returns {Promise<Array>} list of graduation configs
     */
    getBySemester: async (semesterId) => {
        return axios.get(`${Links.graduationConfig.getBySemester}${semesterId}`)
    },

    /**
     * Get all graduation configs for a department
     * @param {number} departmentId the department ID
     * @returns {Promise<Array>} list of graduation configs
     */
    getByDepartment: async (departmentId) => {
        return axios.get(`${Links.graduationConfig.getByDepartment}${departmentId}`)
    },

    /**
     * Get graduation config by ID
     * @param {number} id the graduation config ID
     * @returns {Promise<object>} graduation config data
     */
    getById: async (id) => {
        return axios.get(`${Links.graduationConfig.getById}${id}`)
    },

    /**
     * Delete a graduation config
     * @param {number} id the graduation config ID
     * @returns {Promise<void>}
     */
    delete: async (id) => {
        return axios.delete(`${Links.graduationConfig.delete}${id}`)
    },

    /**
     * Toggle graduation config enabled/disabled
     * @param {number} id the graduation config ID
     * @param {boolean} enabled whether to enable or disable
     * @returns {Promise<object>} updated config
     */
    toggle: async (id, enabled) => {
        return axios.patch(`${Links.graduationConfig.toggle}${id}/toggle?enabled=${enabled}`)
    }
}

export default GraduationConfig
